// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/video_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { AccountStub, FamilyStub, TranscriptionSegment } from "./common_pb.ts";
import { Note } from "./notes_pb.ts";
import { Suggestions } from "./suggestions_pb.ts";

/**
 * @generated from message protogen.CreateVideoRoomRequest
 */
export class CreateVideoRoomRequest extends Message<CreateVideoRoomRequest> {
  /**
   * @generated from field: bool recordingEnabled = 1;
   */
  recordingEnabled = false;

  /**
   * @generated from field: string familyRef = 2;
   */
  familyRef = "";

  constructor(data?: PartialMessage<CreateVideoRoomRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateVideoRoomRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "recordingEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateVideoRoomRequest {
    return new CreateVideoRoomRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateVideoRoomRequest {
    return new CreateVideoRoomRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateVideoRoomRequest {
    return new CreateVideoRoomRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateVideoRoomRequest | PlainMessage<CreateVideoRoomRequest> | undefined, b: CreateVideoRoomRequest | PlainMessage<CreateVideoRoomRequest> | undefined): boolean {
    return proto3.util.equals(CreateVideoRoomRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateVideoRoomResponse
 */
export class CreateVideoRoomResponse extends Message<CreateVideoRoomResponse> {
  /**
   * @generated from field: protogen.VideoRoom videoRoom = 1;
   */
  videoRoom?: VideoRoom;

  /**
   * @generated from field: string accessToken = 2;
   */
  accessToken = "";

  constructor(data?: PartialMessage<CreateVideoRoomResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateVideoRoomResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "videoRoom", kind: "message", T: VideoRoom },
    { no: 2, name: "accessToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateVideoRoomResponse {
    return new CreateVideoRoomResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateVideoRoomResponse {
    return new CreateVideoRoomResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateVideoRoomResponse {
    return new CreateVideoRoomResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateVideoRoomResponse | PlainMessage<CreateVideoRoomResponse> | undefined, b: CreateVideoRoomResponse | PlainMessage<CreateVideoRoomResponse> | undefined): boolean {
    return proto3.util.equals(CreateVideoRoomResponse, a, b);
  }
}

/**
 * @generated from message protogen.JoinVideoRoomRequest
 */
export class JoinVideoRoomRequest extends Message<JoinVideoRoomRequest> {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid = "";

  /**
   * @generated from field: bool hostRejoin = 2;
   */
  hostRejoin = false;

  constructor(data?: PartialMessage<JoinVideoRoomRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.JoinVideoRoomRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hostRejoin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinVideoRoomRequest {
    return new JoinVideoRoomRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinVideoRoomRequest {
    return new JoinVideoRoomRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinVideoRoomRequest {
    return new JoinVideoRoomRequest().fromJsonString(jsonString, options);
  }

  static equals(a: JoinVideoRoomRequest | PlainMessage<JoinVideoRoomRequest> | undefined, b: JoinVideoRoomRequest | PlainMessage<JoinVideoRoomRequest> | undefined): boolean {
    return proto3.util.equals(JoinVideoRoomRequest, a, b);
  }
}

/**
 * @generated from message protogen.JoinVideoRoomResponse
 */
export class JoinVideoRoomResponse extends Message<JoinVideoRoomResponse> {
  /**
   * @generated from field: protogen.VideoRoom videoRoom = 1;
   */
  videoRoom?: VideoRoom;

  /**
   * @generated from field: string token = 2;
   */
  token = "";

  /**
   * @generated from field: protogen.AccountStub host = 3;
   */
  host?: AccountStub;

  /**
   * @generated from field: repeated protogen.AccountStub participants = 4;
   */
  participants: AccountStub[] = [];

  /**
   * @generated from field: protogen.Note note = 5;
   */
  note?: Note;

  /**
   * @generated from field: protogen.FamilyStub family = 6;
   */
  family?: FamilyStub;

  /**
   * @generated from field: protogen.Suggestions suggestions = 7;
   */
  suggestions?: Suggestions;

  constructor(data?: PartialMessage<JoinVideoRoomResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.JoinVideoRoomResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "videoRoom", kind: "message", T: VideoRoom },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "host", kind: "message", T: AccountStub },
    { no: 4, name: "participants", kind: "message", T: AccountStub, repeated: true },
    { no: 5, name: "note", kind: "message", T: Note },
    { no: 6, name: "family", kind: "message", T: FamilyStub },
    { no: 7, name: "suggestions", kind: "message", T: Suggestions },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinVideoRoomResponse {
    return new JoinVideoRoomResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinVideoRoomResponse {
    return new JoinVideoRoomResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinVideoRoomResponse {
    return new JoinVideoRoomResponse().fromJsonString(jsonString, options);
  }

  static equals(a: JoinVideoRoomResponse | PlainMessage<JoinVideoRoomResponse> | undefined, b: JoinVideoRoomResponse | PlainMessage<JoinVideoRoomResponse> | undefined): boolean {
    return proto3.util.equals(JoinVideoRoomResponse, a, b);
  }
}

/**
 * @generated from message protogen.EndVideoRoomRequest
 */
export class EndVideoRoomRequest extends Message<EndVideoRoomRequest> {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid = "";

  constructor(data?: PartialMessage<EndVideoRoomRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.EndVideoRoomRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndVideoRoomRequest {
    return new EndVideoRoomRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndVideoRoomRequest {
    return new EndVideoRoomRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndVideoRoomRequest {
    return new EndVideoRoomRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EndVideoRoomRequest | PlainMessage<EndVideoRoomRequest> | undefined, b: EndVideoRoomRequest | PlainMessage<EndVideoRoomRequest> | undefined): boolean {
    return proto3.util.equals(EndVideoRoomRequest, a, b);
  }
}

/**
 * @generated from message protogen.EndVideoRoomResponse
 */
export class EndVideoRoomResponse extends Message<EndVideoRoomResponse> {
  constructor(data?: PartialMessage<EndVideoRoomResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.EndVideoRoomResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndVideoRoomResponse {
    return new EndVideoRoomResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndVideoRoomResponse {
    return new EndVideoRoomResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndVideoRoomResponse {
    return new EndVideoRoomResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EndVideoRoomResponse | PlainMessage<EndVideoRoomResponse> | undefined, b: EndVideoRoomResponse | PlainMessage<EndVideoRoomResponse> | undefined): boolean {
    return proto3.util.equals(EndVideoRoomResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateVideoRoomRequest
 */
export class UpdateVideoRoomRequest extends Message<UpdateVideoRoomRequest> {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid = "";

  /**
   * @generated from field: bool transcriptionEnabled = 2;
   */
  transcriptionEnabled = false;

  constructor(data?: PartialMessage<UpdateVideoRoomRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateVideoRoomRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transcriptionEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateVideoRoomRequest {
    return new UpdateVideoRoomRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateVideoRoomRequest {
    return new UpdateVideoRoomRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateVideoRoomRequest {
    return new UpdateVideoRoomRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateVideoRoomRequest | PlainMessage<UpdateVideoRoomRequest> | undefined, b: UpdateVideoRoomRequest | PlainMessage<UpdateVideoRoomRequest> | undefined): boolean {
    return proto3.util.equals(UpdateVideoRoomRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateVideoRoomResponse
 */
export class UpdateVideoRoomResponse extends Message<UpdateVideoRoomResponse> {
  /**
   * @generated from field: protogen.VideoRoom videoRoom = 1;
   */
  videoRoom?: VideoRoom;

  constructor(data?: PartialMessage<UpdateVideoRoomResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateVideoRoomResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "videoRoom", kind: "message", T: VideoRoom },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateVideoRoomResponse {
    return new UpdateVideoRoomResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateVideoRoomResponse {
    return new UpdateVideoRoomResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateVideoRoomResponse {
    return new UpdateVideoRoomResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateVideoRoomResponse | PlainMessage<UpdateVideoRoomResponse> | undefined, b: UpdateVideoRoomResponse | PlainMessage<UpdateVideoRoomResponse> | undefined): boolean {
    return proto3.util.equals(UpdateVideoRoomResponse, a, b);
  }
}

/**
 * @generated from message protogen.VideoRoom
 */
export class VideoRoom extends Message<VideoRoom> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: string hostRef = 3;
   */
  hostRef = "";

  /**
   * @generated from field: repeated string participantRefs = 4;
   */
  participantRefs: string[] = [];

  /**
   * @generated from field: int64 creationSec = 5;
   */
  creationSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastUpdatedSec = 6;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: string status = 7;
   */
  status = "";

  /**
   * @generated from field: protogen.VideoRoom.State state = 8;
   */
  state = VideoRoom_State.UNSPECIFIED;

  /**
   * @generated from field: bool transcriptionEnabled = 9;
   */
  transcriptionEnabled = false;

  /**
   * @generated from field: string roomSid = 10;
   */
  roomSid = "";

  constructor(data?: PartialMessage<VideoRoom>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.VideoRoom";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "hostRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "participantRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "creationSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "state", kind: "enum", T: proto3.getEnumType(VideoRoom_State) },
    { no: 9, name: "transcriptionEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "roomSid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VideoRoom {
    return new VideoRoom().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VideoRoom {
    return new VideoRoom().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VideoRoom {
    return new VideoRoom().fromJsonString(jsonString, options);
  }

  static equals(a: VideoRoom | PlainMessage<VideoRoom> | undefined, b: VideoRoom | PlainMessage<VideoRoom> | undefined): boolean {
    return proto3.util.equals(VideoRoom, a, b);
  }
}

/**
 * @generated from enum protogen.VideoRoom.State
 */
export enum VideoRoom_State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATE_CREATING = 1;
   */
  CREATING = 1,

  /**
   * @generated from enum value: STATE_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: STATE_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: STATE_FAILED = 4;
   */
  FAILED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(VideoRoom_State)
proto3.util.setEnumType(VideoRoom_State, "protogen.VideoRoom.State", [
  { no: 0, name: "STATE_UNSPECIFIED" },
  { no: 1, name: "STATE_CREATING" },
  { no: 2, name: "STATE_ACTIVE" },
  { no: 3, name: "STATE_COMPLETED" },
  { no: 4, name: "STATE_FAILED" },
]);

/**
 * @generated from message protogen.GetVideoTranscriptionsRequest
 */
export class GetVideoTranscriptionsRequest extends Message<GetVideoTranscriptionsRequest> {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid = "";

  /**
   * @generated from field: repeated string tracks = 2;
   */
  tracks: string[] = [];

  /**
   * @generated from field: int32 maxTimestampProcessed = 3;
   */
  maxTimestampProcessed = 0;

  /**
   * @generated from field: float startTimeOffset = 4;
   */
  startTimeOffset = 0;

  constructor(data?: PartialMessage<GetVideoTranscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetVideoTranscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tracks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "maxTimestampProcessed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "startTimeOffset", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVideoTranscriptionsRequest {
    return new GetVideoTranscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVideoTranscriptionsRequest {
    return new GetVideoTranscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVideoTranscriptionsRequest {
    return new GetVideoTranscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetVideoTranscriptionsRequest | PlainMessage<GetVideoTranscriptionsRequest> | undefined, b: GetVideoTranscriptionsRequest | PlainMessage<GetVideoTranscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(GetVideoTranscriptionsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetVideoTranscriptionsResponse
 */
export class GetVideoTranscriptionsResponse extends Message<GetVideoTranscriptionsResponse> {
  /**
   * @generated from field: repeated protogen.TranscriptionSegment segments = 1;
   */
  segments: TranscriptionSegment[] = [];

  /**
   * @generated from field: int32 cursorMs = 2;
   */
  cursorMs = 0;

  /**
   * @generated from field: int32 maxTimestampProcessed = 3;
   */
  maxTimestampProcessed = 0;

  /**
   * @generated from field: bool complete = 4;
   */
  complete = false;

  constructor(data?: PartialMessage<GetVideoTranscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetVideoTranscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "segments", kind: "message", T: TranscriptionSegment, repeated: true },
    { no: 2, name: "cursorMs", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "maxTimestampProcessed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVideoTranscriptionsResponse {
    return new GetVideoTranscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVideoTranscriptionsResponse {
    return new GetVideoTranscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVideoTranscriptionsResponse {
    return new GetVideoTranscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetVideoTranscriptionsResponse | PlainMessage<GetVideoTranscriptionsResponse> | undefined, b: GetVideoTranscriptionsResponse | PlainMessage<GetVideoTranscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(GetVideoTranscriptionsResponse, a, b);
  }
}

/**
 * @generated from message protogen.SendVideoInvitationRequest
 */
export class SendVideoInvitationRequest extends Message<SendVideoInvitationRequest> {
  /**
   * @generated from field: string videoRoomUuid = 1;
   */
  videoRoomUuid = "";

  /**
   * @generated from field: string memberRef = 2;
   */
  memberRef = "";

  /**
   * @generated from field: string medium = 3;
   */
  medium = "";

  constructor(data?: PartialMessage<SendVideoInvitationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendVideoInvitationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "videoRoomUuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "memberRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "medium", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendVideoInvitationRequest {
    return new SendVideoInvitationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendVideoInvitationRequest {
    return new SendVideoInvitationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendVideoInvitationRequest {
    return new SendVideoInvitationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendVideoInvitationRequest | PlainMessage<SendVideoInvitationRequest> | undefined, b: SendVideoInvitationRequest | PlainMessage<SendVideoInvitationRequest> | undefined): boolean {
    return proto3.util.equals(SendVideoInvitationRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendVideoInvitationResponse
 */
export class SendVideoInvitationResponse extends Message<SendVideoInvitationResponse> {
  constructor(data?: PartialMessage<SendVideoInvitationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendVideoInvitationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendVideoInvitationResponse {
    return new SendVideoInvitationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendVideoInvitationResponse {
    return new SendVideoInvitationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendVideoInvitationResponse {
    return new SendVideoInvitationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendVideoInvitationResponse | PlainMessage<SendVideoInvitationResponse> | undefined, b: SendVideoInvitationResponse | PlainMessage<SendVideoInvitationResponse> | undefined): boolean {
    return proto3.util.equals(SendVideoInvitationResponse, a, b);
  }
}

